<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="销售人员:" prop="createByName">
        <el-input v-model.trim="searchForm.createByName" placeholder="请输入销售人员姓名" />
      </el-form-item>
      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item label="订单分类:" prop="contractType">
        <el-select v-model="searchForm.contractType" placeholder="请选择" clearable>
          <el-option v-for="option in orderType" :key="option.code" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="最终客户:" prop="clientName">
        <el-input v-model.trim="searchForm.clientName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="供货单位:" prop="supplyUnit">
        <el-select v-model="searchForm.supplyUnit" placeholder="请选择供货单位" clearable>
          <el-option v-for="option in supplyUnit" :key="option.code" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="170" />
        <el-table-column prop="contractNum" label="合同编号" align="left" min-width="140" />
        <el-table-column prop="contractType" label="订单分类" align="left">
          <template v-slot="{row}">
            <span v-if="row.freightContract">{{ row.contractType +'(价外费用)' }}</span>
            <span v-else>{{ row.contractType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractSum" label="订单金额" align="right" min-width="100" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.contractSum).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="salesManName" label="销售人员" align="left" />
        <el-table-column prop="createTime" label="合同时间" align="left" min-width="140" />
        <el-table-column prop="name" label="操作" align="left" width="100" fixed="right">
          <template v-slot="{row}">
            <!--<el-button type="text" @click="printPdf(row)">打印</el-button>-->
            <el-button type="text" @click="$router.push({name:'doSeal',params:{contractNum:row.id}})">
              操作
            </el-button>
            <!--<el-button type="text" @click="goEsing(row)">签章</el-button>-->
          </template>
        </el-table-column>
        <!--<el-table-column prop="date" label="合同附件" width="80" align="left">-->
        <!--<template v-slot="{row}" />-->
        <!--</el-table-column>-->
        <!--<el-table-column prop="date" label="电子签章" width="80" align="left">-->
        <!--<template v-slot="{row}" />-->
        <!--</el-table-column>-->
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <a ref="pdflink" :href="`/pdf/web/viewer.html?file=${pdflink}`" target="_blank" />
    <do-esign ref="doEsign" @CompleteEsign="CompleteEsign" />
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import doEsign from '@/components/doEsign';
import { selectContractInfoList, electronicSignature, printContractPDF } from '@/API';
export default {
  data () {
    return {
      searchForm: {
        projectName: '',
        contractNum: '',
        contractProcessStatus: 2,
        createByName: '',
        contractType: '',
        clientName: '',
        supplyUnit: '',
        createBeginTime: '',
        createEndTime: ''

      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      pdflink: ''
    };
  },
  components: {
    doEsign
  },
  computed: {
    ...mapState({
      orderType: state => state.enumeration.orderType,
      supplyUnit: state => state.enumeration.supplyUnit
    })
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.contractNum = (e.target.value || '').trim();
    },
    doSearch () {
      this.tableLoading = true;
      selectContractInfoList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    goEsing (row) {
      electronicSignature(row.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$refs.doEsign.openWindow(json.data, row);
        }
      }).catch(() => {

      });
    },
    CompleteEsign (val) {
      if (val.isComplete) {
        this.$router.push({
          name: 'doSeal',
          params: {
            contractNum: val.other.id
          }
        });
      }
    },
    printPdf (row) {
      printContractPDF(row.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.pdflink = encodeURIComponent(json.data);
          this.$nextTick(() => {
            this.$refs.pdflink.click();
          });
        }
      }).catch(() => {

      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
